import { gql } from '@apollo/client'

export const UPDATE_GLOBAL_OPTIMIZATION_CADENCE = gql`
  mutation UpdateGlobalOptimizationSchedule(
    $input: GlobalUpdateOpitimizationCadenceInput!
  ) {
    globalUpdateOptimizingCadence(input: $input) {
      success
      numTimesOptimizeHighPerYear
      numTimesOptimizeMediumPerYear
      numTimesOptimizeLowPerYear
      timesPerWeekTwoDScan
    }
  }
`
